import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getMinePosts, getPostCounts } from "../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import PaginationforConstestActive from "./PaginationforConstestActive";
import PaginationforContestCompleted from "./PaginationforContestCompleted";
import { getMyOrderContestList } from "../../../../redux/contest/action";
import PaginationforConstestPaymentPending from "./PaginationforConstestPaymentPending";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import PaginationforContestCancelled from "./PaginationforContestCancelled";

export default function PaginationforContests() {
  const path = "Assets/scss/myorders.module.scss";
  const { urlstate, setMyAllContestListroute } = useRouteBaseStateContext();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [activeTab, setActiveTab] = useState("paymentpendingcontest");
  const dispatch = useDispatch();
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);


  useEffect(() => {
    dispatch(getPostCounts(2));
  }, [dispatch]);

  useEffect(() => {
    if (urlstate?.myallconstestlistroute) {
      setActiveTab(urlstate?.myallconstestlistroute || "paymentpendingcontest");
    } else {
      setActiveTab("paymentpendingcontest");
    }
  }, [urlstate, urlstate?.myallconstestlistroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyAllContestListroute(tab);
  };
  return (
    <>
      <div className="order-section manage-project">
        <div className="tab-sec">
          <div className="order-first">
            <h2>My Orders</h2>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("paymentpendingcontest")}
                  className={`nav-link ${activeTab == "paymentpendingcontest" ? "active" : ""}`}
                >
                  Payment Pending Contest (
                  {postcounts?.posted_orders?.payment_pending_contest || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("activeconstest")}
                  className={`nav-link ${activeTab == "activeconstest" ? "active" : ""}`}
                >
                  Active Contest ({postcounts?.posted_orders?.contest || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("active")}
                  className={`nav-link ${activeTab == "active" ? "active" : ""}`}
                >
                  Completed Contest (
                  {postcounts?.completed_orders?.contest || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("Cancelled")}
                  className={`nav-link ${activeTab == "Cancelled" ? "active" : ""}`}
                >
                  Cancelled Contest (
                  {postcounts?.cancelled_orders?.contest || 0})
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            {activeTab == "paymentpendingcontest" && (
              <div className="tab-pane active" id="paymentpendingcontest">
                <PaginationforConstestPaymentPending />
              </div>
            )}
            {activeTab == "activeconstest" && (
              <div className="tab-pane active" id="activeconstest">
                <PaginationforConstestActive />
              </div>
            )}
            {activeTab == "active" && (
              <div className="tab-pane active" id="active">
                <PaginationforContestCompleted />
              </div>
            )}
            {activeTab == "Cancelled" && (
              <div className="tab-pane active" id="Cancelled">
                <PaginationforContestCancelled />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
